<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogRoleList" persistent max-width="750px">
    <v-card class="pa-3">
      <v-card-title>
        <span class="txt-head">มีรายการข้อมูลจากไฟล์ซ้ำในระบบ </span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="dialogRoleList = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <!-- <span class="dialog-memeber-title ml-5 mt-3">{{this.groupCompanyName}}</span> -->
      <!-- <h1 class="ra-head-text-bold mb-0 ml-6" style="color: #333333;">{{groupCompanyName }}</h1> -->
      <v-card-text>
        <!-- <v-row v-if="this.leaderName === '-'" justify="space-around">
          <span class="txt-leader-title">ยังไม่มีข้อมูลหัวหน้า</span>
        </v-row> -->
        <v-row class="mt-0" justify=center>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        <span class="ra-head-text-bold"><span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรุณาแก้ไขรายการที่ซ้ำและทำการอัปโหลดไฟล์อีกครั้ง)</span></span>

        </v-row>
        <v-container style="padding: 0px;">
          <!-- <TableMember/> -->
        <v-row class="mb-0 mt-0" >
          <v-col cols="7" class="mt-5">
            <span class="txt-font" style="font-weight: bold; font-color: #333333">รายการที่ซ้ำในระบบ</span>
            <v-chip
              v-if="desserts.length !== 0"
              class="ml-2 mb-1 mt-0"
              color="#EFF4FD"
              text-color="#3776E9"
              small
            >
              <span>{{desserts.length}}</span>
            </v-chip>
          </v-col>
          <v-col cols="5">
            <v-spacer/>
            <v-text-field
              v-model="search"
              outlined
              dense
              clearable
              class="mt-2"
              placeholder="ค้นหาจากชื่อตำแหน่ง"
            >
            <template v-slot:append>
              <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
            </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="desserts.length === 0" class="mt-2 rounded-lg" justify="center" fixed centered style="background-color: #fff; height: 300px;">
          <v-col cols="8">
          </v-col>
          <v-col cols="8" class="text-center mt-12" style="margin-top: 5%;">
            <img width="150" height="110" src="@/assets/icons/create-employee.png">
            <p class="" style="font-weight: bold;">ยังไม่มีข้อมูลสิทธิ์</p>
            <p class="ra-head-text">ค้นหาสิทธิ์ที่คุณต้องการเพิ่ม</p>
          </v-col>
          <v-col cols="8" class="pt-0 pb-0 d-flex align-center justify-center mt-4" style="margin-top: -1%;">
          </v-col>
          <div
            class="pt-0 d-flex flex-row align-center justify-end"
            color="grey lighten-2"
            flat
            tile
          ></div>
        </v-row>
        <v-data-table
          v-if="desserts.length !== 0"
          :headers="headers"
          :items="desserts"
          :search="search"
          class="elevation-0"
          :loading="loading"
          loading-text="Loading... Please wait"
          :footer-props="{
            'items-per-page-options': [10, 30, 50, 100, -1],
            'items-per-page': 10
          }"
          :server-items-length="total || -1"
          @update:items-per-page="changePerPage"
          @update:page="changePage"
          disable-sort
          dense
        >
        <template v-slot:[`item.no`]="{ item }">
          <td style="height: 50px;">
            {{ (perPage*(page-1)) + desserts.indexOf(item)+1 }}
          </td>
        </template>
        </v-data-table>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn class="ra-button1" color="#1654C6" outlined @click="closeDialog">ยกเลิก</v-btn>
      <v-btn class="ra-button1" color="#1654C6" dark @click="confirmApprove()">เพิ่มผู้ดูแล</v-btn> -->
      <v-btn class="" color="#3776E9" dark @click="closeDialog()">อัปโหลดไฟล์อีกครั้ง</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
  </v-dialog>
</div>
</template>

<script>
import { } from '@/API/API'
import { EventBus } from '@/EventBus'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading'
export default {
  components: {
    OverlayLoading
  },
  data () {
    return {
      loading: false,
      dialogRoleList: false,
      textTitle: '',
      groupCompanyName: '',
      countMember: 0,
      search: '',
      selectFilter: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no',
          height: '25px',
          width: '100px'
        },
        { text: 'ชื่อตำแหน่ง', value: 'positionName' },
        { text: 'ระดับตำแหน่ง', value: 'positionLevel' },
        { text: 'บรรทัดที่', value: 'duplicateLineNew' }
        // duplicateLine
        // { text: 'Actions', value: 'actions', sortable: false }
      ],
      itemCompany: [
        'INET',
        'OGS'
      ],
      desserts: [{
        name: 'Dev',
        no: '1'
      }
      ],
      total: -1,
      perPage: 15,
      page: 1
    }
  },
  beforeDestroy () {
    EventBus.$off('opendialogCheckFilePosition')
  },
  mounted () {
    EventBus.$on('opendialogCheckFilePosition', this.openDialogRoleList)
    // EventBus.$on('opendialogmemberDepartment', this.openDialogMember)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
  },
  computed: {
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      // this.initDataTable()
    },
    changePage (value) {
      this.page = value
      // this.initDataTable()
    },
    openDialogRoleList (value) {
      const temp = []
      value.map((el, index) => {
        const newStr = el.duplicateLine.replace(/line/g, '')
        const newStr2 = newStr.replace(/ and /g, ',')
        temp.push({
          no: index + 1,
          duplicateLineNew: newStr2,
          ...el
        })
      })
      this.desserts = temp
      // this.loading = true
      this.search = ''
      this.dialogRoleList = true
    },
    closeDialog () {
      this.desserts = []
      this.dialogRoleList = false
      this.search = ''
      EventBus.$emit('closedialogCheckFile')
    },
    submitEdit (preName) {
      this.dialogCreate = false
      this.preName = ''
    }
  }
}
</script>
<style scoped>
/* .txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
} */
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.txt-leader-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
.border-img {
  border-radius: 15px;
}
</style>
